import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AppInsightsService } from '../shared/services/app-insights.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Erro conhecido do DataTables ao destruir tabela já removida do DOM (ex.: ao abrir modal/visualização)
    if (this.isDataTablesParentNodeError(error)) {
      return;
    }
    const appInsights = this.injector.get(AppInsightsService);
    if (error instanceof Error) {
      appInsights.trackException(error);
    } else {
      appInsights.trackException(new Error(JSON.stringify(error)));
    }
    console.error('[GlobalErrorHandler]', error);
  }

  /** Erro conhecido ao destruir/atualizar DataTables com tabela já fora do DOM (carregamento, modal, etc.). */
  private isDataTablesParentNodeError(error: any): boolean {
    if (!error) return false;
    const msg = typeof error?.message === 'string' ? error.message : '';
    return (
      error?.name === 'TypeError' &&
      msg.includes("Cannot read properties of null (reading 'parentNode')")
    );
  }
}
